module.exports = __webpack_public_path__ + "img/kasidit_p.608c741b.webp";